import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import * as yup from "yup";

const adicionarContatosSchema = yup.object().shape({
  emails: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string(),
        email: yup
          .string()
          .required(mensagemDeErroPadrao("E-mail"))
          .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "E-mail inválido!"),
      })
    )
    .required(),

  telefonesProprietario: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string(),
        numeroFormatado: yup
          .string()
          .transform((telefone: string) => telefone.replaceAll("_", "").replaceAll(" ", ""))
          .required(mensagemDeErroPadrao("Telefone"))
          .min(13, "Digite um telefone válido")
          .max(14, "Digite um telefone válido"),
      })
    )
    .required(),
});

export default adicionarContatosSchema;
